import styled from "styled-components"
import Img from "gatsby-image"
import Breakpoints from "../shared/breakpoints"

export const MappedinValuesWrapper = styled.div`
  display: none;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / -1;
    display: grid;
    flex-wrap: wrap;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    grid-row-gap: 48px;
    margin-top: 64px;
    margin-bottom: 64px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / -2;
    grid-gap: 96px;
    grid-row-gap: 96px;
  }
`
export const ContentWrapper = styled.div`
  margin-top: 48px;

  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 64px;

  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 176px;
  }
`

export const ValuesCardSliderWrapper = styled.div`
  overflow: hidden;
  grid-column: 1 / -1;
  margin-top: 48px;
  margin-bottom: 64px;
  & .slick-prev {
    transform: translate3d(20px, 0, 0);
  }
  & .slick-next {
    transform: translate3d(-20px, 0, 0);
  }

  .slick-dots {
    bottom: -32px;
  }
`

export const EmployeePhoto = styled(Img)`
  width: 100vw;
`